// @flow

/**
 * Typing Indicator Component
 * Animated dots indicating active processing
 */

import styled, { keyframes } from 'styled-components';

const dotPulse = keyframes`
  0% { opacity: 0.2; transform: translateY(0); }
  20% { opacity: 1; transform: translateY(-1px); }
  40% { opacity: 0.2; transform: translateY(0); }
  100% { opacity: 0.2; transform: translateY(0); }
`;


const TypingIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  min-height: 1em;
  & i {
    margin-right: 0.3rem; /* ensure space between status text and dots */
  }
  & span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--blue);
    animation: ${dotPulse} 1.2s infinite ease-in-out both;
  }
  & span:nth-of-type(2) {
    animation-delay: 0.15s;
  }
  & span:nth-of-type(3) {
    animation-delay: 0.3s;
  }
`;

export default TypingIndicator;
